import {SmartComponent} from "smart-component-js";
import $ from "jquery";
import moment from "moment";
import Constants from "../business/Constants";
import PromoApi from "mbpromo/src/api/PromoApi";
class DefaultCtrl extends SmartComponent {

	constructor(element, parentComponent, params) {
		super(element, parentComponent, params);
		this.promoApi = new PromoApi({promoCode: Constants.API_PROMOCODE});
		this.init();
	}
	init() {
		this.loadChildComponents(this);

		this.promoApi.status().then((resp) => {
			let response = resp.body.response.data;

			if(moment(response.promo.dates.receipt_end_date.raw).diff(moment()) < 0){
				$('.closingStep1').show();
			}else{
				$('.beforeClosing').show();
			}
		});
	}
}

export default DefaultCtrl;
